import React from "react"
import { computed } from "mobx"
import { observer } from "mobx-react"
import { Button, Col, Flex, List, Row, Typography } from "antd"

import { IconCopy } from "@src/app/components/icons/copy"
import { notify } from "@src/app/components/notify"
import { TopupBankAccountDetails } from "@src/shared/api/generated"

type Props = {
  details: TopupBankAccountDetails
  feePercent?: string
  symbol: string
}
export const DepositFiatInfoList = observer(
  ({ details, feePercent, symbol }: Props) => {
    const listInfo = computed<[string, string][]>(() => {
      return [
        ["Bank Name", details.bank_name],
        ["Bank Swift", details.bic_swift_code],
        ["Bank Address", details.bank_address],
        ["IBAN", symbol !== "EUR" ? details.iban : undefined],
        [
          "Beneficiary",
          symbol !== "EUR" ? details.beneficiary_account_name : undefined,
        ],
        ["Address", symbol !== "EUR" ? details.beneficiary_address : undefined],
      ] as [string, string][]
    }).get()

    const copy = (v: string) => {
      navigator.clipboard.writeText(v).then(() => notify.success("Copied"))
    }

    return (
      <Flex gap={24} vertical>
        <List
          dataSource={listInfo}
          renderItem={([title, value], index) => (
            <List.Item key={index}>
              <Row align={"middle"} gutter={16} style={{ width: "100%" }}>
                <Col span={8}>
                  <Typography.Text>{title}</Typography.Text>
                </Col>

                <Col span={14}>
                  <Typography.Text>{value ?? "-"}</Typography.Text>
                </Col>

                <Col span={2}>
                  {Boolean(value) && (
                    <Typography.Text>
                      <Button
                        icon={<IconCopy />}
                        id="GENERATED_ID_DEPOSITFIATINFOLIST_BUTTON_VOID_1"
                        onClick={() => copy(value)}
                        size="small"
                        type="text"
                      ></Button>
                    </Typography.Text>
                  )}
                </Col>
              </Row>
            </List.Item>
          )}
        />

        <Flex
          align={"center"}
          justify={"space-between"}
          style={{ backgroundColor: "#E9F1EA", borderRadius: 4, padding: 16 }}
        >
          <Typography.Text strong style={{ fontSize: 16 }}>
            Top-Up fee:
          </Typography.Text>

          <Typography.Text strong style={{ fontSize: 16 }}>
            {feePercent}%
          </Typography.Text>
        </Flex>
      </Flex>
    )
  },
)
